import useNavStore from "./store";

export default useNavStore;
